const OfferDescriptionModel = {
  title: { pl: '' },
  content: { pl: '' },
  position: 1,
  userMustBeLoggedIn: false,
  userMustInvest: false,
};

export default OfferDescriptionModel;
